import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { fontSecondaryOblique, scrollbar } from 'src/theme/mixins';
import { SimpleDialog } from '@enuan/m3mgr-utils';
import { mainFrameRefContext } from '../Frame/context';
import { ReactComponent as CloseIcon } from '@/assets/close.svg';
import classNames from 'classnames';

export type IModalProps = {
	title?: React.ReactNode;
	actions?: React.ReactNode;
	open: boolean;
	onClose: () => void;
	className?: string;
};

export const Modal = styled(
	(props: React.PropsWithChildren<IModalProps>) => {
		const chatFrameRef = useContext(mainFrameRefContext);

		return (
			<SimpleDialog
				container={chatFrameRef}
				closeButton={<CloseIcon className={classNames('icon', 'close')} />}
				{...props}
			/>
		);
	},
	{
		target: 'Modal-root',
		label: 'Modal',
	},
)({
	position: 'absolute',
	zIndex: 10,
	'& .MuiModal-backdrop': {
		backgroundColor: 'var(--chat__modal__overlay_background)',
	},
	'& .SimpleDialog-paper': {
		color: 'var(--chat__modal_color)',
		backgroundColor: 'var(--chat__modal_background)',
		border: 'solid 1px var(--chat__modal_border)',
		borderRadius: '0.6em',
		borderBottomRightRadius: 0,
		minWidth: '15em',
		maxWidth: '80%',
		maxHeight: '41%',
	},
	'& .SimpleDialog-header': {
		padding: '10px',
		color: 'var(--chat__modal__header_color)',
		'& .SimpleDialog-titleWrapper': {
			...fontSecondaryOblique,
			fontSize: '1em',
			fontWeight: 'bold',
			flex: 1,
			justifyContent: 'center',
		},
		'& .SimpleDialog-close': {
			cursor: 'pointer',
			fontSize: '1em',
			fontFamily: "'Roboto', sans-serif",
			fontWeight: 400,
			'& .icon.close': {
				color: 'var(--chat__modal__close_color)',
				fontSize: '1em',
				marginRight: '0.2em',
				height: '1em',
				'& .st0': {
					stroke: 'none',
					fill: 'var(--chat__modal__close_color)',
				},
			},
		},
		// '& h5': {
		// 	fontSize: 'inherit',
		// 	fontWeight: 'inherit',
		// 	margin: 0,
		// },
	},
	'& .MuiDialogContent-root': {
		...scrollbar(),
		maxHeight: '150px',
	},

	'& .MuiDialogActions-root': {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '0.5em',
		color: 'var(--chat__modal__footer_color)',
	},
});
